import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CsPaginatorComponent } from './cs-paginator.component';
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { CsPaginatorIntl } from './es-paginator-intl';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  imports: [
    CommonModule,
    MatPaginatorModule,
    MatSelectModule,
    FormsModule,
    FlexLayoutModule,
    TranslocoModule
  ],
  declarations: [
    CsPaginatorComponent
  ],
  exports: [
    CsPaginatorComponent
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CsPaginatorIntl }
  ]
})
export class CsPaginatorModule { }
